module.exports = __webpack_public_path__ + "img/crow-tools-lockup-primarybg.5d3e4fcd.svg";